const Loader = () => {
  return <div></div>;
};

export default Loader;
